import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  IEtrmConfig,
} from '.';
import { BidClient } from '../core/clients';
import { axiosToObservable } from '../core/clients/axiosToObservable';

export class EtrmConfigService {
  getAllEtrmConfig = (): Observable<IEtrmConfig[]> => {
    return axiosToObservable(BidClient.get<IEtrmConfig[]>('EtrmConfig/GetAllEtrmConfig/')).pipe(
      map((config: IEtrmConfig[]) => {
        return config;
      })
    );
  };

  postEtrmConfigUpdate = (etrmConfig: IEtrmConfig): Observable<any> => {
    return axiosToObservable(BidClient.post('EtrmConfig/Update/', etrmConfig)).pipe(
      map((response: any) => {
        return response;
      })
    );
  };
}



